import React from 'react'
import './Carregando.scss'

const Carregando = () => {
    return (
        <div className="areaLoader">
            <div className="loader"></div>
        </div>
    )
}

export default Carregando
